<template>
  <v-card class="mx-auto" max-width="500">
    <v-img src="../../assets/CoverPageImage/CoverPage.jpg"></v-img>

    <v-list-item>
      <v-list-item-content>
        <v-btn text @click="goToSub(category.name,category.articleList, category.title)">
          <p class="title text-center justify-center red--text font-weight-bold">{{category.title}}</p>
        </v-btn>
      </v-list-item-content>
    </v-list-item>
  </v-card>
</template>

<script>
export default {
  props: ["category"],
  methods: {
    goToSub: function(page, list, title) {
      this.$router.push({
        name: page,
        params: { articleList: list, pageTitle: title }
      });
    }
  }
};
</script>